// ticket-service.js - Versione corretta con gestione errori migliorata

import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class PraticheService {
  constructor(http, eventBus) {
    this.http = http
    this.eventBus = eventBus
    this.praticheUrl = `${services.ask_pratiche.url}/ticket`
    this.filemanager = new FileManager()
  }

  async getInfoAreaTicket() {
    let items = []
    const url = `${this.praticheUrl}/info/area`

    try {
      let res = await this.http.get(url)
      const data = res?.data
      if (data?.success && Array.isArray(data?.data)) {
        items = data.data
      }
    } catch (err) {
      console.error('Errore in getInfoAreaTicket:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      items = []
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items }
  }

  async getInfoCategoryTicket() {
    try {
      const res = await this.http.get(`${this.praticheUrl}/info/category`)
      const data = res?.data
      if (data?.success && Array.isArray(data?.data)) {
        return { items: data.data }
      }
      return { items: [] }
    } catch (err) {
      console.error('Errore in getInfoCategoryTicket:', err)
      this.eventBus.emit('data-load-error', { message: err, url: `${this.praticheUrl}/info/category` })
      return { items: [] }
    }
  }

  async getInfoAndamentoAggregato() {
    try {
      const res = await this.http.get(`${this.praticheUrl}/info/andamento-aggregato`)
      const data = res?.data
      if (data?.success && data?.data) {
        return { success: true, data: data.data }
      }
      return { success: false, data: null }
    } catch (err) {
      console.error('Errore in getInfoAndamentoAggregato:', err)
      this.eventBus.emit('data-load-error', { message: err, url: `${this.praticheUrl}/info/andamento-aggregato` })
      return { success: false, data: null }
    }
  }

  async getInfoAndamentoTicket(params = {}) {
    const { id_ticket_area, area_id, area_code, id_category_motivation, category_id } = params
    const id = id_ticket_area ?? area_id
    const categoryId = id_category_motivation ?? category_id
    if (!id && !area_code && !categoryId) {
      return { success: false, data: null }
    }
    const query = {}
    if (categoryId) query.id_category_motivation = categoryId
    else if (id) query.id_ticket_area = id
    else query.area_code = area_code

    try {
      const res = await this.http.get(`${this.praticheUrl}/info/andamento`, { params: query })
      const data = res?.data
      if (data?.success) {
        return { success: true, data: data.data }
      }
      return { success: false, data: null }
    } catch (err) {
      console.error('Errore in getInfoAndamentoTicket:', err)
      this.eventBus.emit('data-load-error', { message: err, url: `${this.praticheUrl}/info/andamento` })
      return { success: false, data: null }
    }
  }

  async getInfoDetailTickets(params = {}) {
    const { id_ticket_area, area_id, area_code, status_code, tipo_stato, page = 1, per_page = 15, sort_field, sort_order, id_category_motivation, category_id } = params
    const id = id_ticket_area ?? area_id
    const categoryId = id_category_motivation ?? category_id
    if (!id && !area_code && !categoryId) return { success: false, data: [], pagination: null }
    const status = status_code ?? tipo_stato
    if (!status) return { success: false, data: [], pagination: null }

    const query = { page, per_page, status_code: status }
    if (categoryId) query.id_category_motivation = categoryId
    else if (id) query.id_ticket_area = id
    else query.area_code = area_code
    if (sort_field) query.sort_field = sort_field
    if (sort_order) query.sort_order = sort_order

    try {
      const res = await this.http.get(`${this.praticheUrl}/info/detail-tickets`, { params: query })
      const data = res?.data
      if (data?.success) {
        return { success: true, data: data.data || [], pagination: data.pagination || null }
      }
      return { success: false, data: [], pagination: null }
    } catch (err) {
      console.error('Errore in getInfoDetailTickets:', err)
      this.eventBus.emit('data-load-error', { message: err, url: `${this.praticheUrl}/info/detail-tickets` })
      return { success: false, data: [], pagination: null }
    }
  }

  async getInfoTicketDetail(idTicket) {
    if (!idTicket) return { success: false, data: null }
    try {
      const res = await this.http.get(`${this.praticheUrl}/info/ticket/${idTicket}`)
      const data = res?.data
      if (data?.success) {
        return { success: true, data: data.data }
      }
      return { success: false, data: null }
    } catch (err) {
      console.error('Errore in getInfoTicketDetail:', err)
      this.eventBus.emit('data-load-error', { message: err, url: `${this.praticheUrl}/info/ticket/${idTicket}` })
      return { success: false, data: null }
    }
  }

  async getMailThread(idTicket) {
    if (!idTicket) return { success: false, data: null }
    const url = `${this.praticheUrl}/ticket/${idTicket}/mail-thread`
    try {
      const res = await this.http.get(url)
      const data = res?.data
      if (data?.success) {
        return { success: true, data: data.data }
      }
      return { success: false, data: null }
    } catch (err) {
      console.error('Errore in getMailThread:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      return { success: false, data: null }
    }
  }

  async getTypesAreaTicket() {
    let items = []
    const url = `${this.praticheUrl}/types/area`

    try {
      let res = await this.http.get(url)
      // Verifica che la risposta abbia la struttura corretta
      if (res && res.data) {
        items = Array.isArray(res.data) ? res.data : []
      }
    } catch (err) {
      console.error('Errore in getTypesAreaTicket:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      items = [] // Assicurati che ritorna sempre un array
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { items }
  }

  async getTypesEntity() {
    let items = []
    const url = `${this.praticheUrl}/types/entity`

    try {
      let res = await this.http.get(url)
      // Verifica che la risposta abbia la struttura corretta
      if (res && res.data) {
        items = Array.isArray(res.data) ? res.data : []
      }
    } catch (err) {
      console.error('Errore in getTypesEntity:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      items = [] // Fallback su array vuoto
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { items }
  }

  async getTicketEntity(string, type) {
    let items = []
    const url = `${this.praticheUrl}/ticket/entity`

    try {
      let res = await this.http.post(url, { string, type })
      if (res && res.data) {
        items = Array.isArray(res.data) ? res.data : []
      }
    } catch (err) {
      console.error('Errore in getTicketEntity:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      items = []
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { items }
  }

  async getStatus() {
    let items = []
    const url = `${this.praticheUrl}/status`

    try {
      let res = await this.http.get(url)
      if (res && res.data) {
        items = Array.isArray(res.data) ? res.data : []
      }
    } catch (err) {
      console.error('Errore in getStatus:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      items = []
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { items }
  }

  async getTickets(page = 1, perPage = 5, filters = {}) {
    let items = []
    let mail = []
    let unreadTotal = null
    let pagination = {
      current_page: 1,
      per_page: perPage,
      total: 0,
      last_page: 1,
      from: 0,
      to: 0
    }
    const url = `${this.praticheUrl}/tickets`

    const params = {
      page,
      per_page: perPage
    }

    if (filters.search) params.search = filters.search
    if (filters.author) params.author = filters.author
    if (filters.status && filters.status.length > 0) params.status = filters.status
    if (filters.department && filters.department.length > 0) params.department = filters.department
    if (filters.numberId) params.number_id = filters.numberId
    if (filters.unread !== undefined) params.unread = filters.unread
    if (filters.assigned !== undefined) params.assigned = filters.assigned
    if (filters.pin_richiamami) params.pin_richiamami = true
    if (filters.mail_scope) params.mail_scope = filters.mail_scope
    if (filters.includeMail !== undefined) params.include_mail = filters.includeMail ? 1 : 0
    if (filters.areaAssignedOnly !== undefined) params.area_assigned_only = filters.areaAssignedOnly

    try {
      let res = await this.http.get(url, { params })
      if (res && res.data) {
        console.log(res.data, Array.isArray(res.data.data));
        if (res.data.data && Array.isArray(res.data.data)) {
          items = res.data.data
          mail = Array.isArray(res.data.mail) ? res.data.mail : []
          if (res.data.unread_total !== undefined && res.data.unread_total !== null) {
            unreadTotal = res.data.unread_total
          }
          pagination = {
            current_page: res.data.current_page || 1,
            per_page: res.data.per_page || perPage,
            total: res.data.total || 0,
            last_page: res.data.last_page || 1,
            from: res.data.from || 0,
            to: res.data.to || 0
          }
        } else if (Array.isArray(res.data)) {
          items = res.data
        }
      }
    } catch (err) {
      console.error('Errore in getTickets:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      items = [] 
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { items, pagination, mail, unreadTotal }
  }

  async getTicketDetails(ticket) {
    const idTicket = ticket?.id_ticket ?? ticket?.id
    return this.getInfoTicketDetail(idTicket)
  }

  async getTicketRecipients(string, type) {
    let items = []
    const url = `${this.praticheUrl}/ticket/recipients`

    try {
      let res = await this.http.post(url, { string, type })
      if (res && res.data) {
        items = Array.isArray(res.data) ? res.data : []
      }
    } catch (err) {
      console.error('Errore in getTicketRecipients:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      items = []
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { items }
  }

  async createTicket(ticket) {
    let success = false
    const url = `${this.praticheUrl}/ticket/create`

    try {
      let res = await this.http.post(url, { ticket })
      if (res && res.data) {
        success = res.data
      }
    } catch (err) {
      console.error('Errore in createTicket:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { success }
  }

  async sendMessage(ticketId, messageContent, files = [], idAssignedUser = null, options = {}) {
    let data = false
    const url = `${this.praticheUrl}/message/create`

    let fd = new FormData();
    for (let i = 0; i < files.length; i++) {
      fd.append('attachments[]', files[i]);
    }
    fd.append('ticketId', ticketId)
    fd.append('messageContent', messageContent)
    if (idAssignedUser) {
      fd.append('id_assigned_user', idAssignedUser)
    }

    const callTransfer = options.callTransfer ?? null
    if (callTransfer && callTransfer.success !== null && callTransfer.success !== undefined && callTransfer.success !== '') {
      fd.append('call_transfer[success]', callTransfer.success ? '1' : '0')
      if (callTransfer.id_ticket_area) {
        fd.append('call_transfer[id_ticket_area]', callTransfer.id_ticket_area)
      }
    }

    try {
      let res = await this.http.post(url, fd)
      if (res && res.data) {
        data = res.data
      }
    } catch (err) {
      console.error('Errore in sendMessage:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { data }
  }

  async setMessageAsRead(messages) {
    let data = false
    const url = `${this.praticheUrl}/messages/mark/read`

    try {
      let res = await this.http.post(url, { messages })
      if (res && res.data) {
        data = res.data
      }
    } catch (err) {
      console.error('Errore in setMessageAsRead:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { data }
  }

  async changeStatus(ticketId, newStatus) {
    let success = false
    const url = `${this.praticheUrl}/change/status`

    try {
      let res = await this.http.post(url, { ticketId, newStatus })
      if (res && res.data) {
        success = res.data
      }
    } catch (err) {
      console.error('Errore in changeStatus:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { success }
  }

  async assignTicket(ticketId, assignObj) {
    let success = false
    const url = `${this.praticheUrl}/assign`

    try {
      let res = await this.http.post(url, { ticketId, assignObj })
      if (res && res.data) {
        success = res.data
      }
    } catch (err) {
      console.error('Errore in assignTicket:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { success }
  }

  async addContestazioneFromTicket(numeroFattura) {
    let item = null
    const url = `${services.ask_pratiche.url}/ticket/contestazione/add-from-ticket`

    try {
      const payload = {
        numero_fattura: numeroFattura,
        numeroFattura: numeroFattura,
        numero: numeroFattura,
      }
      const res = await this.http.post(url, payload)
      if (res && res.data) {
        item = res.data
      }
    } catch (err) {
      console.error('Errore in addContestazioneFromTicket:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      item = { success: false, message: 'Errore durante blocco sospensione' }
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { item }
  }

  async checkContestazioneFromTicket(numeroFattura) {
    let item = null
    const url = `${services.ask_pratiche.url}/ticket/contestazione/check-from-ticket`

    try {
      const payload = {
        numero_fattura: numeroFattura,
        numeroFattura: numeroFattura,
        numero: numeroFattura,
      }
      const res = await this.http.post(url, payload)
      if (res && res.data) {
        item = res.data
      }
    } catch (err) {
      console.error('Errore in checkContestazioneFromTicket:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      item = { success: false, message: 'Errore durante check contestazione' }
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { item }
  }

  async getNewTicketsNumbers() {
    let items = 0
    const url = `${this.praticheUrl}/tickets/new/numbers`

    try {
      let res = await this.http.get(url)
      if (res && res.data) {
        items = res.data
      }
    } catch (err) {
      console.error('Errore in getNewTicketsNumbers:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { items }
  }

  async downloadAttachment(attachment) {
    const url = `${this.praticheUrl}/download/attachment`
    try {
      let res = await this.http({
        url,
        method: 'POST',
        data: attachment,
        responseType: 'blob',
      })

      this.filemanager.download(res)

    } catch (err) {
      console.error('Errore in downloadAttachment:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async fetchAttachmentBlob(attachment) {
    const url = `${this.praticheUrl}/download/attachment`
    const res = await this.http({
      url,
      method: 'POST',
      data: attachment,
      responseType: 'blob',
    })
    return res?.data instanceof Blob ? res.data : new Blob([res?.data])
  }

  async openAttachment(attachment) {
    const url = `${this.praticheUrl}/download/attachment`
    try {
      let res = await this.http({
        url,
        method: 'POST',
        data: attachment,
        responseType: 'blob',
      })

      this.filemanager.open(res)

    } catch (err) {
      console.error('Errore in openAttachment:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getStatistiche(){
    let items = 0
    const url = `${this.praticheUrl}/get-statistiche`

    try {
      let res = await this.http.get(url)
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return { items }
  }

  async getStatisticheAgenti(params = {}) {
    const url = `${this.praticheUrl}/get-statistiche-agenti`

    try {
      const res = await this.http.get(url, {
        params: {
          id_agente: params.id_agente,
          data_da: params.data_da,
          data_a: params.data_a,
          page: params.page,
          per_page: params.per_page,
        },
      })
      return res?.data ?? { success: false }
    } catch (err) {
      console.error('Errore in getStatisticheAgenti:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      return {
        success: false,
        message: err?.response?.data?.message || 'Errore nel caricamento delle statistiche agenti.',
      }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getStatisticheCategorie(params = {}) {
    const url = `${this.praticheUrl}/get-statistiche-categorie`

    try {
      const res = await this.http.get(url, {
        params: {
          data_da: params.data_da,
          data_a: params.data_a,
        },
      })
      return res?.data ?? { success: false }
    } catch (err) {
      console.error('Errore in getStatisticheCategorie:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      return {
        success: false,
        message: err?.response?.data?.message || 'Errore nel caricamento delle statistiche categorie.',
      }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getStatisticheCategorieTickets(params = {}) {
    const url = `${this.praticheUrl}/get-statistiche-categorie/tickets`

    try {
      const res = await this.http.get(url, {
        params: {
          data_da: params.data_da,
          data_a: params.data_a,
          id_category_motivation: params.id_category_motivation,
          category_id: params.category_id,
          status_code: params.status_code,
          page: params.page,
          per_page: params.per_page,
          sort_field: params.sort_field,
          sort_order: params.sort_order,
        },
      })
      return res?.data ?? { success: false }
    } catch (err) {
      console.error('Errore in getStatisticheCategorieTickets:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      return {
        success: false,
        message: err?.response?.data?.message || 'Errore nel caricamento dei ticket della categoria.',
      }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getDistribuzioneAssistenza(params = {}) {
    const url = `${this.praticheUrl}/distribuzione-assistenza`
    try {
      const res = await this.http.get(url, { params })
      return res?.data ?? { success: false }
    } catch (err) {
      console.error('Errore in getDistribuzioneAssistenza:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      return { success: false }
    }
  }

  async getStatisticheTrasferimentiChiamata(params = {}) {
    const url = `${this.praticheUrl}/get-statistiche-trasferimenti-chiamata`

    try {
      const res = await this.http.get(url, {
        params: {
          data_da: params.data_da,
          data_a: params.data_a,
        },
      })
      return res?.data ?? { success: false }
    } catch (err) {
      console.error('Errore in getStatisticheTrasferimentiChiamata:', err)
      this.eventBus.emit('data-load-error', { message: err, url })
      return {
        success: false,
        message: err?.response?.data?.message || 'Errore nel caricamento delle statistiche trasferimenti.',
      }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }
}